const videoObj = {
  desert: require("../assets/public/video/scenery/desert.mp4"),
  field: require("../assets/public/video/scenery/field.mp4"),
  mountains: require("../assets/public/video/scenery/mountains.mp4"),
  snow: require("../assets/public/video/scenery/snow.mp4"),
  space: require("../assets/public/video/scenery/space.mp4"),
  swamp: require("../assets/public/video/scenery/swamp.mp4"),
  home: require("../assets/public/video/home.mp4"),
};

export { videoObj };
